// import React, { useState, useEffect, memo, forwardRef } from "react";
// import API from "api.js";
// import { Link } from "react-router-dom";
// import ArrowImg from "assets/images/images_new/practice-arrow.svg";
// import calendarImg from "assets/images/images_new/calendar-icon.svg";
// import ClockImg from "assets/images/images_new/clock-icon.svg";
// import SelectOption from "components/PracticeMaterial/SelectOption";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
// import AvailableBands from "data/availableBands.js";
// import MicrophoneIcon from "assets/images/images_new/headset-icon.png";
// import { useDispatch, useSelector } from "react-redux";
// import { setUser } from "action";

// const Stats = memo(function Stats({ mockData, practiceData, examDatePopup, examPopupDate, loadDashboardData, estimatedScore }) {
//   const dispatch = useDispatch();
//   const user = useSelector((state) => state.user)
//   const [desiredScore, setDesiredScore] = useState("0");
//   const [practiceDays, setPracticeDays] = useState("0");
//   const [examDate, setExamDate] = useState("0");

//   const [isOpen, setIsOpen] = useState(false);
//   const toggle = () => setIsOpen((prevState) => !prevState);

//   const [examIsOpen, setExamIsOpen] = useState(false);
//   const toggleExam = () => setExamIsOpen((prevState) => !prevState);

//   const saveDesiredScore = (e, score) => {
//     API({
//       url: "updateTargetScore",
//       method: "POST",
//       data: { target_score: score },
//     })
//       .then((res) => {
//         toggle();
//         setDesiredScore(score);
//          dispatch(setUser({ ...user, score: parseInt(score) }));
//       })
//       .catch((err) => {
//         console.log("err", err);
//       });
//   };

//   const saveExamDate = (e, selected_date) => {
//     API({
//       url: "updateExamDate",
//       method: "POST",
//       data: { exam_date: selected_date },
//     })
//       .then((res) => {
//         const { days_left } = res.data;
//         loadDashboardData();
//         toggleExam();
//         setExamDate(days_left);

//       })
//       .catch((err) => {
//         console.log("err", err);
//       });
//   };

//   useEffect(() => {
//     if (mockData) {
//       // selectObject(mockData.desired_score);
//       // if (mockData.desired_score == null || mockData.desired_score == undefined){
//       //   setDesiredScore(null);
//       // } else {
//       //   setDesiredScore(mockData.desired_score);
//       // }
//       setDesiredScore(mockData.desired_score);
//       setExamDate(mockData.days_left);
//     }
//   }, [mockData]);

//   useEffect(() => {
//     if (practiceData) {
//       setPracticeDays(practiceData.days);
//     }
//   }, [practiceData]);

//   useEffect(() => {
//     // console.log('exam_date :- ',examDatePopup)
//     setExamIsOpen(examDatePopup);
//   }, [examDatePopup]);

//   return (
//     <>
//       <div id="tour-practice-btn" className="col-md-6 col-xl-7 pr-md-0">
//         <div className="dashboard-card mt-0">
//           <h2 className="title">My Stats</h2>
//           <div className="stats-row d-flex flex-column gap-2">
//             <div className="stats-cards">
//               <StatCard
//                 data={mockData}
//                 class_name="total-mocks"
//                 labelOne="Total Mocks"
//                 labelTwo="Practiced"
//               />

//               <StatCardOther
//                 count={desiredScore == null || desiredScore == undefined || desiredScore == "null"|| desiredScore=="undefined" ? "N/A" : desiredScore}
//                 class_name="desired-score"
//                 labelOne="Desired"
//                 labelTwo="Score"
//                 toggle={toggle}
//                 isPopup={true}
//               />

//               <StatCard
//                 data={practiceData}
//                 class_name="questions-practiced"
//                 labelOne="Questions"
//                 labelTwo="Practiced"
//               />

//               <StatCardOther
//                 count={practiceDays}
//                 class_name="days-practiced"
//                 labelOne="Days"
//                 labelTwo="Practiced"
//               />

//               {/* <div className="stats-btns border-0 p-0 m-0">
// 								<Link to="practice-detail" className="stats-btn btn-block">
// 									<img src={calendarImg} alt="LA" /> See History
// 								</Link>
// 								<Link to="daily-feedback" className="stats-btn btn-block">
// 									<img src={ClockImg} alt="LA" /> Daily Feedback
// 								</Link>
// 							</div> */}

//               {/* <div className="exam-date-card m-0 w-100">
// 								<div className="exam-date-content border-0 p-0">
// 									<StatCardOther
// 										count={examDate}
// 										class_name="days-practiced"
// 										labelOne="Exam"
// 										labelTwo="Date"
// 										toggle={toggleExam}
// 										allowCountText={true}
// 										isPopup={true}
// 									/>
// 								</div>
// 							</div> */}

//               {/* <StatCard
// 								data={practiceData}
// 								class_name="questions-practiced"
// 								labelOne="Questions"
// 								labelTwo="Practiced"
// 							/>

// 							<StatCardOther
// 								count={practiceDays}
// 								class_name="days-practiced"
// 								labelOne="Days"
// 								labelTwo="Practiced"
// 							/> */}
//             </div>
//             <div className={`d-flex gap-2 w-100 ${estimatedScore ? "justify-content-around flex-md-column flex-lg-row" : ""}`}>
//               {/* <div className={`exam-date-card d-flex flex-column ${estimatedScore ? "w-auto" : "w-100"}`}> */}
//               <div className={"exam-date-card d-flex flex-column w-100"}>
//                 <div className="exam-date-content">
//                   <StatCardOther
//                     count={examDate}
//                     class_name="days-practiced"
//                     labelOne="Exam Date"
//                     labelThree={mockData?.exam_date}
//                     toggle={toggleExam}
//                     allowCountText={true}
//                     isPopup={true}
//                   />
//                 </div>
//                 <div className="stats-btns">
//                   <Link
//                     to="/admin/practice-detail"
//                     className="stats-btn btn-block"
//                   >
//                     <img src={calendarImg} alt="LA" /> See History
//                   </Link>
//                   <Link
//                     to="/admin/daily-feedback"
//                     className="stats-btn btn-block"
//                   >
//                     <img src={ClockImg} alt="LA" /> Daily Feedback
//                   </Link>
//                 </div>
//               </div>
//               {
//                 !!estimatedScore && (
//                   <div className="dashboard-card microphone-card col-lg-5 position-relative relative d-flex flex-column">
//                     <h2 className="title">Microphone Setup</h2>
//                     <div className="microphone-card-content">
//                       <img src={MicrophoneIcon} alt="Microphone Setup" />
//                     </div>
//                     <Link className="microphone-link" to="/admin/mic-setup"></Link>
//                   </div>
//                 )
//               }
//             </div>
//           </div>
//         </div>
//       </div>

//       {isOpen && (
//         <ScorePopup
//           isOpen={isOpen}
//           toggle={toggle}
//           submit={saveDesiredScore}
//           desiredScore={desiredScore}
//         />
//       )}

//       {examIsOpen && (
//         <ExamPopup
//           isOpen={examIsOpen}
//           toggle={toggleExam}
//           submit={saveExamDate}
//           examDate={examPopupDate}
//         />
//       )}
//     </>
//   );
// });
// export default Stats;

// const StatCard = ({ data, labelOne, labelTwo, class_name }) => {
//   const [practiced, setPracticed] = useState(0);

//   useEffect(() => {
//     if (data) {
//       setPracticed(data.count);
//     }
//   }, [data]);

//   return (
//     <div className={`stats-card ${class_name}`}>
//       <div className="count">{practiced}</div>
//       <p>
//         {labelOne}
//         <br />
//         {labelTwo}
//       </p>
//     </div>
//   );
// };

// const StatCardOther = ({
//   labelOne,
//   labelTwo,
//   class_name,
//   dataKey,
//   allowCountText,
//   toggle,
//   count,
//   isPopup,
//   labelThree
// }) => {
//   const pointer_class = isPopup ? "cursor-pointer" : "";

//   const popupHandler = () => {
//     if (isPopup) toggle();
//   };

//   return (
//     // <div className={`stats-card ${class_name} ${pointer_class}`} onClick={popupHandler}>
//     <div className={`stats-card ${class_name} `} onClick={popupHandler}>
//       <div className="d-flex align-items-center">
//         <div className="count">
//           {count} {allowCountText && <span>Days Left</span>}
//         </div>
//         <span className="d-flex flex-column gap-1 mx-2">
//           <p>
//             {labelOne}
//             <br />
//             {labelTwo}
//           </p>
//           <p className="exam-date-label">{labelThree}</p>
//         </span>
//       </div>
//       {isPopup && (
//         <div className="arrow-icon">
//           <img src={ArrowImg} alt="LA" />
//         </div>
//       )}
//     </div>
//   );
// };

// const ExamPopup = ({ isOpen, toggle, submit, examDate }) => {
//   const [selectedDate, setSelectedDate] = useState(null);

//   useEffect(() => {
//     if (examDate && new Date(examDate) > new Date()) {
//       setSelectedDate(new Date(examDate));
//     } else {
//       setSelectedDate(new Date());
//     }
//   }, [examDate]);

//   const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
//     <div className="w-100" onClick={onClick} ref={ref}>
//       <div className="voice-dropdown-toggle w-100 d-flex justify-content-between align-items-center px-2 btn btn-light" style={{ backgroundColor: "white", color: "black", border: "1px solid #ced4da" }}>
//         <span>{value || "Select Date"}</span>
//       </div>
//     </div>
//   ));

//   return (
//     <Modal isOpen={isOpen} centered className="text-translate-modal">
//       <ModalHeader className="text-translation" tag="div">
//         Set Exam Date
//         <Button className="modalCloseBtn" onClick={() => toggle()}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 24 24"
//             width="24"
//             height="24"
//           >
//             <path
//               d="M18 6L6 18M6 6l12 12"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//         </Button>
//       </ModalHeader>
//       <ModalBody>
//         <div className="row">
//           <h2 className="translate-title">Select Exam Date</h2>
//           <div className="w-100">
//             <DatePicker
//               selected={selectedDate}
//               onChange={(date) => setSelectedDate(date)}
//               minDate={new Date()}
//               customInput={<CustomDateInput />}
//               calendarClassName="custom-calendar-300"
//               popperPlacement="bottom-start"
//               dateFormat="yyyy-MM-dd"
//             />
//           </div>
//         </div>
//       </ModalBody>
//       <ModalFooter>
//         <Button
//           className="close-button"
//           onClick={(e) => submit(e, selectedDate ? selectedDate.toISOString().split("T")[0] : "")}
//         >
//           Save Exam Date
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// const ScorePopup = ({ isOpen, toggle, submit, desiredScore }) => {
//   const [bands, setBands] = useState([]);
//   const [selected, setSelected] = useState({
//     value: 0,
//     label: "Select",
//   });

//   const changeSelected = (selectedValue) => {
//     selectObject(selectedValue);
//   };

//   const selectObject = (value) => {
//     let item = AvailableBands.filter((band, i) => {
//       return parseInt(band.value) === parseInt(value);
//     });

//     if (item.length > 0) {
//       setSelected(item[0]);
//     }
//   };

//   useEffect(() => {
//     setBands(AvailableBands);
//     selectObject(desiredScore);
//   }, []);

//   return (
//     <Modal isOpen={isOpen} centered className="text-translate-modal">
//       <ModalHeader className="text-translation" tag="div">
//         Set Desired Score
//         <Button className="modalCloseBtn" onClick={() => toggle()}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             viewBox="0 0 24 24"
//             width="24"
//             height="24"
//           >
//             <path
//               d="M18 6L6 18M6 6l12 12"
//               stroke="currentColor"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             />
//           </svg>
//         </Button>
//       </ModalHeader>
//       <ModalBody>
//         <div className="row">
//           <h2 className="translate-title">Select Desired Score</h2>
//           {selected && (
//             <SelectOption
//               isClearable={false}
//               selected={selected}
//               data={bands.filter((band, i) => {
//                 return band.value !== selected.value;
//               })}
//               changeEvent={changeSelected}
//             />
//           )}
//         </div>
//       </ModalBody>
//       <ModalFooter>
//         <Button
//           className="close-button"
//           onClick={(e) => submit(e, selected.value)}
//         >
//           Save Score
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

import React, { useState, useEffect, memo, forwardRef, useRef } from "react";
import API from "api.js";
import { Link, useNavigate } from "react-router-dom";
import ArrowImg from "assets/images/images_new/practice-arrow.svg";
import calendarImg from "assets/images/images_new/calendar-icon.svg";
import ClockImg from "assets/images/images_new/clock-icon.svg";
import SelectOption from "components/PracticeMaterial/SelectOption";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import AvailableBands from "data/availableBands.js";
import MicrophoneIcon from "assets/images/images_new/headset-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "action";
import Report from "assets/images/green-report.svg"
import Graph from "assets/images/blue-graph.svg"
import Clock from "assets/images/orange-clock.svg"
import { BsArrowRightShort } from "react-icons/bs";

const Stats = memo(function Stats({ mockData, practiceData, examDatePopup, examPopupDate,loadDashboardData ,estimatedScore}) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user)
  const [desiredScore, setDesiredScore] = useState("0");
  const [practiceDays, setPracticeDays] = useState("0");
  const [examDate, setExamDate] = useState("0");

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((prevState) => !prevState);

  const [examIsOpen, setExamIsOpen] = useState(false);
  const toggleExam = () => setExamIsOpen((prevState) => !prevState);

  const [scoreSaving, setScoreSaving] = useState(false);
  const scoreSavingRef = useRef(false);

  const saveDesiredScore = (e, score) => {
    if (scoreSavingRef.current) return;
    scoreSavingRef.current = true;
    setScoreSaving(true);
    API({
      url: "updateTargetScore",
      method: "POST",
      data: { target_score: score },
    })
      .then((res) => {
        toggle();
        setDesiredScore(score);
        console.log("USer Score before the Dispatch : ", user.score);
         dispatch(setUser({ ...user, score: parseInt(score) }));
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        scoreSavingRef.current = false;
        setScoreSaving(false);
      });
  };

  const saveExamDate = (e, selected_date) => {
    return API({
      url: "updateExamDate",
      method: "POST",
      data: { exam_date: selected_date },
    })
      .then((res) => {
        const { days_left } = res.data;
        loadDashboardData();
        toggleExam();
        setExamDate(days_left);

      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (mockData) {
      // selectObject(mockData.desired_score);
      // if (mockData.desired_score == null || mockData.desired_score == undefined){
      //   setDesiredScore(null);
      // } else {
      //   setDesiredScore(mockData.desired_score);
      // }
      setDesiredScore(mockData.desired_score);
      setExamDate(mockData.days_left);
      if (mockData.desired_score != null) {
      dispatch(setUser({ ...user, score: parseInt(mockData.desired_score) }));
    }
    }
  }, [mockData]);

  useEffect(() => {
    if (practiceData) {
      setPracticeDays(practiceData.days);
    }
  }, [practiceData]);

  // useEffect(() => {
  //   setExamIsOpen(examDatePopup);
  // }, [examDatePopup]);

  return (
    <>
      <div id="tour-practice-btn" className=" pr-md-0">
        <div className="dashboard-stats-card mt-0">
          {/* <h2 className="title">My Stats</h2> */}
          <div className="stats-row d-flex flex-column gap-2">
            <div className="stats-cards">
              <StatCard
                data={mockData}
                class_name="total-mocks"
                labelOne={mockData?.count}
                labelTwo="Total Mocks Practiced"
                img={Report}
                bgColor={"#21BC0314"}
                color={"#21BC03"}
                btnText={"Start Test"}
                link={"/admin/mock"}
              />
              <StatCard
                data={practiceData}
                class_name="questions-practiced"
                labelOne={practiceData?.count}
                labelTwo="Total Questions Practiced"
                img={Clock}
                bgColor={"#FFB02C14"}
                color={"#FFB02C"}
                btnText={"See History"}
                link={"/admin/practice-detail"}
              />
              <StatCard
                data={mockData}
                class_name="desired-score"
                labelOne={desiredScore == null || desiredScore == undefined || desiredScore == "null"|| desiredScore=="undefined" ? "N/A" : desiredScore}
                labelTwo="Desired Score"
                img={Graph}
                bgColor={"#0286FF14"}
                color={"#0286FF"}
                btnText={"Set Desired Score"}
                popupHandler={toggle}
              />

              {/* <StatCardOther
                count={desiredScore == null || desiredScore == undefined || desiredScore == "null"|| desiredScore=="undefined" ? "N/A" : desiredScore}
                class_name="desired-score"
                labelOne="Desired"
                labelTwo="Score"
                toggle={toggle}
                isPopup={true}
              /> */}
            </div>
          </div>
        </div>
      </div>

      {isOpen && (
        <ScorePopup
          isOpen={isOpen}
          toggle={toggle}
          submit={saveDesiredScore}
          desiredScore={desiredScore}
          loading={scoreSaving}
        />
      )}

      {examIsOpen && (
        <ExamPopup
          isOpen={examIsOpen}
          toggle={toggleExam}
          submit={saveExamDate}
          examDate={examPopupDate}
        />
      )}
    </>
  );
});
export default Stats;

const StatCard = ({ data, labelOne, labelTwo, class_name ,color,btnText,bgColor,img,link,popupHandler}) => {
  const [practiced, setPracticed] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setPracticed(data.count);
    }
  }, [data]);

  console.log("data",data);
  console.log("practiced",practiced);



  return (
    <div className={`stats-card ${class_name}`} onClick={popupHandler}>
     <div className="d-flex align-items-center justify-content-between gap-2">
         <div className="count">
          <img src={img} alt="stats"/>
         </div>
      <div className="d-flex flex-column align-items-start">
        <p className="FS28FW700 fw-700 m-0">
        {labelOne || 0}
      </p>
      <p className="question-practiced m-0 text-start">{labelTwo}</p>
      </div>
     </div>
     <button className="stats-card-btn" 
     style={{backgroundColor:color ? bgColor : "", color : color ? color : ""}}
     onClick={() => navigate(link)}
     >
      {btnText}
      <BsArrowRightShort color={color} fontSize={"20px"}/>
     </button>
    </div>
  );
};

const ExamPopup = ({ isOpen, toggle, submit, examDate }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (examDate && new Date(examDate) > new Date()) {
      setSelectedDate(new Date(examDate));
    } else {
      setSelectedDate(new Date());
    }
  }, [examDate]);

  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <div className="w-100" onClick={onClick} ref={ref}>
      <div className="voice-dropdown-toggle w-100 d-flex justify-content-between align-items-center px-2 btn btn-light" style={{ backgroundColor: "white", color: "black", border: "1px solid #ced4da" }}>
        <span>{value || "Select Date"}</span>
      </div>
    </div>
  ));

  return (
    <Modal isOpen={isOpen} centered className="text-translate-modal">
      <ModalHeader className="text-translation" tag="div">
        Set Exam Date
        <Button className="modalCloseBtn" onClick={() => toggle()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <h2 className="translate-title">Select Exam Date</h2>
          <div className="w-100">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              minDate={new Date()}
              customInput={<CustomDateInput />}
              calendarClassName="custom-calendar-300"
              popperPlacement="bottom-start"
              dateFormat="yyyy-MM-dd"
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="close-button"
          onClick={(e) => submit(e, selectedDate ? selectedDate.toISOString().split("T")[0] : "")}
        >
          Save Exam Date
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const ScorePopup = ({ isOpen, toggle, submit, desiredScore, loading }) => {
  const [bands, setBands] = useState([]);
  const [selected, setSelected] = useState({
    value: 0,
    label: "Select",
  });
  const [error, setError] = useState("");

  const changeSelected = (selectedValue) => {
    selectObject(selectedValue);
    setError("");
  };

  const selectObject = (value) => {
    let item = AvailableBands.filter((band, i) => {
      return parseInt(band.value) === parseInt(value);
    });

    if (item.length > 0) {
      setSelected(item[0]);
    }
  };

  const handleSubmit = (e) => {
    if (!selected.value || parseInt(selected.value) === 0) {
      setError("Please select a desired score");
      return;
    }
    submit(e, selected.value);
  };

  useEffect(() => {
    setBands(AvailableBands);
    selectObject(desiredScore);
  }, []);

  return (
    <Modal isOpen={isOpen} centered className="text-translate-modal">
      <ModalHeader className="text-translation" tag="div">
        Set Desired Score
        <Button className="modalCloseBtn" onClick={() => toggle()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </ModalHeader>
      <ModalBody>
        <div className="row">
          <h2 className="translate-title">Select Desired Score</h2>
          {selected && (
            <SelectOption
              isClearable={false}
              selected={selected}
              data={bands.filter((band, i) => {
                return band.value !== selected.value;
              })}
              changeEvent={changeSelected}
            />
          )}
          {error && <p style={{ color: "red", fontSize: "13px", marginTop: "5px", marginBottom: "0" }}>{error}</p>}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          className="close-button"
          disabled={loading}
          onClick={handleSubmit}
        >
          {loading ? "Saving..." : "Save Score"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
